/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  // DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/shadcnComponents/ui/dropdown-menu";
import { Button } from "@/shadcnComponents/ui/button";
import { Card } from "@/shadcnComponents/ui/card";
import { Link } from "react-router-dom";

function ArrowRightIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5 12h14" />
      <path d="m12 5 7 7-7 7" />
    </svg>
  );
}

interface ISelectProps {
  values: {
    key: string;
    value: string;
  }[];
  selectedValue: string[];
  setSelectedValue: React.Dispatch<React.SetStateAction<string[]>>;
}

export const MultiSelect = ({
  values,
  selectedValue,
  setSelectedValue,
}: ISelectProps) => {
  const handleSelectChange = (value: string) => {
    if (!selectedValue?.includes(value)) {
      setSelectedValue((prev) => [...prev, value]);
    } else {
      const referencedArray = [...selectedValue];
      const indexOfItemToBeRemoved = referencedArray.indexOf(value);
      referencedArray?.splice(indexOfItemToBeRemoved, 1);
      setSelectedValue(referencedArray);
    }
  };

  const isOptionSelected = (value: string): boolean => {
    return selectedValue?.includes(value) ? true : false;
  };
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger className="bg-black" asChild>
          <Button
            variant="outline"
            className="flex gap-2 font-bold text-[#fff] "
          >
            <span>Filter</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="w-auto border-[#262626] bg-black text-[#fff] border-none "
          onCloseAutoFocus={(e) => e.preventDefault()}
        >
          {/* <DropdownMenuLabel>Appearance</DropdownMenuLabel> */}
          <DropdownMenuSeparator />
          {values?.map((value: ISelectProps["values"][0], index: number) => {
            return (
              <DropdownMenuCheckboxItem
                onSelect={(e) => e.preventDefault()}
                key={index}
                checked={isOptionSelected(value.key)}
                onCheckedChange={() => handleSelectChange(value.key)}
              >
                {value.value}
              </DropdownMenuCheckboxItem>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};

export const ToolsCard = ({
  toolName,
  toolWebsite,
  toolDescription,
  toolSubDescription,
  toolCategory,
  toolIcon,
}: {
  toolName: string;
  toolWebsite: string;
  toolDescription: string;
  toolSubDescription: string;
  toolCategory: string;
  toolIcon?: string;
}) => {
  return (
    <Card className="group bg-card-bright font-inter overflow-hidden relative p-4 pb-10 border-[#262626] bg-[rgba(255,_255,_255,_0.02)]  shadow-none cursor-pointer transition-all duration-500 hover:-translate-y-1 hover:shadow-2xl">
      <div className="absolute z-10 bottom-2 right-4 bg-[#381c1c] group-hover:bg-[#393738] text-white px-2 py-1 rounded-md text-xs font-medium">
        {toolCategory}
      </div>
      <span className="absolute top-5 z-0 h-10 w-10 rounded-md bg-[#381c1c] transition-all duration-500 group-hover:scale-[150]"></span>

      <div className="flex relative z-10 items-center justify-between mb-4">
        <div className="bg-[#381c1c] p-0.5 flex items-center justify-center rounded-md shadow-m">
          <img
            src={toolIcon ?? `https://logo.clearbit.com/:${toolWebsite}`}
            alt={toolName}
            width={40}
            height={40}
            className="rounded-md shadow-lg"
            onError={(e: any) => {
              if (e.target.src !== `${toolWebsite}favicon.ico`) {
                e.target.onerror = null;
                e.target.src = `${toolWebsite}favicon.ico`;
              }
            }}
            style={{ aspectRatio: "40/40", objectFit: "cover" }}
          />
        </div>
        <Link
          to={toolWebsite}
          className="inline-flex text-xs items-center font-medium text-[#DC2627] group-hover:text-[#fff] hover:underline"
        >
          <span>Visit {toolName}</span>
          <ArrowRightIcon className="ml-2 h-4 w-4" />
        </Link>
      </div>
      <h2 className="mb-2 relative z-10 text-xl font-bold">{toolName}</h2>
      <p className="mb-4 relative z-10 text-md text-muted-foreground-bright">
        {toolDescription}
      </p>
      <p className="relative z-10 text-sm text-muted-foreground-bright">
        {toolSubDescription}
      </p>
    </Card>
  );
};
